import { FISCAL_DOC_ISSUANCE_MODE } from "constants/taxes";

import type { ItfNewFiscalDocIssuance } from "types/taxes";

export const RAPPI_LOGO: { src: string; alt: string } = {
  src: "https://heru-static-assets.s3.us-east-2.amazonaws.com/alliances/rappi.svg",
  alt: "rappi logo",
};

export const INIT_VALUES_NEW_RETENTION_RAPPI: Partial<ItfNewFiscalDocIssuance> = {
  document: FISCAL_DOC_ISSUANCE_MODE.tax_retention.value,
  customer_name: "RAPPI_MX",
  specifications: {
    periodicity: "01",
    services: [
      {
        payment_type: "02",
        payment_method: "PUE",
        service_type: "02",
        service_sub_type: "01",
      },
    ],
  },
  conditions: {
    needs_computation_approval: 1,
    needs_status_validation: 1,
  },
};

export const RAPPI_PROVIDER = 'rappi';
